import * as Types from '../../../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCustomItemsQueryVariables = Types.Exact<{
  priceListId: Types.Scalars['ID'];
}>;


export type GetCustomItemsQuery = { readonly __typename?: 'Query', readonly priceListV2: { readonly __typename?: 'PriceListV2Queries', readonly customItems: { readonly __typename?: 'CustomItemsResponse', readonly items: ReadonlyArray<{ readonly __typename?: 'CustomItem', readonly id: string, readonly name: string }> } } };


export const GetCustomItemsDocument = gql`
    query getCustomItems($priceListId: ID!) {
  priceListV2 {
    customItems(input: {priceListId: $priceListId}) {
      items {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetCustomItemsQuery__
 *
 * To run a query within a React component, call `useGetCustomItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomItemsQuery({
 *   variables: {
 *      priceListId: // value for 'priceListId'
 *   },
 * });
 */
export function useGetCustomItemsQuery(baseOptions: Apollo.QueryHookOptions<GetCustomItemsQuery, GetCustomItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomItemsQuery, GetCustomItemsQueryVariables>(GetCustomItemsDocument, options);
      }
export function useGetCustomItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomItemsQuery, GetCustomItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomItemsQuery, GetCustomItemsQueryVariables>(GetCustomItemsDocument, options);
        }
export type GetCustomItemsQueryHookResult = ReturnType<typeof useGetCustomItemsQuery>;
export type GetCustomItemsLazyQueryHookResult = ReturnType<typeof useGetCustomItemsLazyQuery>;
export type GetCustomItemsQueryResult = Apollo.QueryResult<GetCustomItemsQuery, GetCustomItemsQueryVariables>;